






import { Component, Prop, Vue, Emit } from "vue-property-decorator";

@Component
export default class LabeledText extends Vue {
  @Prop() label!: string;
  @Prop() text!: string;

  @Emit()
  click() {}
}
